import { createSlice } from "@reduxjs/toolkit";

export const notificationSlice = createSlice({
  name: "notification",
  initialState: {
    list: [],
    number: 1,
  },
  reducers: {
    setNotification: (state, action) => {
      console.log("setNotification", action.payload);
      state.list = action.payload.list;
    },
    setNumber: (state, action) => {
      console.log("setNumber", action.payload);
      state.number = action.payload.number;
    },
  },
});

export const { setNotification, setNumber } = notificationSlice.actions;

export default notificationSlice.reducer;
